import { BaseClient } from './baseClient';

/** What the gateway will say about a company to a signed-out visitor. */
export interface CompanyPreview {
    name: string;
    status: string;
    website: string | null;
}

export class OnboardingClient extends BaseClient {
    /** POST /onboarding/preview — read only; null when the email's domain is not a company we know. */
    async previewCompany(email: string): Promise<CompanyPreview | null> {
        const response = await this.api.post<{ company: CompanyPreview | null }>('/onboarding/preview', { email });
        return response.data.company;
    }
}

export default new OnboardingClient();
